import inboxPlusStore from 'owa-mail-inbox-plus-store/lib/store/Store';
import { isFocusedInboxEnabled } from './FocusedInboxUtil';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';

/**
 * Gets default InboxClassificationFilter for selected folder
 * @param folderId of the folder
 */
export default function getDefaultInboxClassificationFilterForFolder(
    folderId: string
): InboxClassificationFilter {
    if (folderIdToName(folderId) !== 'inbox') {
        return InboxClassificationFilter.None;
    }

    if (!isInboxPlusEnabled()) {
        // If the user is not on the inbox plus flight, return the default table's InboxClassification filter
        return isFocusedInboxEnabled()
            ? InboxClassificationFilter.Focused
            : InboxClassificationFilter.None;
    }

    // User is on inbox plus flight in the Inbox folder. Return the leftmost enabled pivot.
    const inboxPlusPivots = inboxPlusStore.inboxPlusPivots;
    for (const pivot of inboxPlusPivots) {
        if (pivot.isEnabled) {
            return pivot.InboxClassificationFilter;
        }
    }

    return InboxClassificationFilter.None;
}
